const { useState, useEffect } = wp.element;
const { useBlockProps } = wp.blockEditor;
import { Flex, Icon, FlexBlock, SelectControl, __experimentalToggleGroupControl, __experimentalToggleGroupControlOptionIcon, TextControl, __experimentalUnitControl as UnitControl, FlexItem } from '@wordpress/components';
import { useSelect } from '@wordpress/data';
import { setAttributesResponsive } from '../../block/functions.js';
import './dimensions.css';

const DimensionsControl = ({ attributes, setAttributes, onChange, attributeName }) => {
    
    const currentDevice = useSelect((select) => {
        return select('core/edit-post').__experimentalGetPreviewDeviceType();
    }, []);
    const device = currentDevice.toLowerCase();
    const deviceString = device === 'desktop' ? '' : `:${device}`;

    return (
        <div className="softlite-rectangle-container">
            <TextControl
                onChange={(newValue) => setAttributesResponsive(attributeName + '.top', newValue, device, setAttributes, attributes)}
                value={attributes?.[attributeName + deviceString]?.top}
                className="softlite-rectangle-input softlite-top-input softlite-text-center"
                placeholder="Top"
            />
            <div className="softlite-middle-row">
                <TextControl
                    onChange={(newValue) => setAttributesResponsive(attributeName + '.left', newValue, device, setAttributes, attributes)}
                    value={attributes?.[attributeName + deviceString]?.left}
                    className="softlite-rectangle-input softlite-side-input softlite-left-input softlite-text-center"
                    placeholder="Left"
                />
                <div className="softlite-rectangle"></div>
                <TextControl
                    onChange={(newValue) => setAttributesResponsive(attributeName + '.right', newValue, device, setAttributes, attributes)}
                    value={attributes?.[attributeName + deviceString]?.right}
                    className="softlite-rectangle-input softlite-side-input softlite-right-input softlite-text-center"
                    placeholder="Right"
                />
            </div>
            <TextControl
                onChange={(newValue) => setAttributesResponsive(attributeName + '.bottom', newValue, device, setAttributes, attributes)}
                value={attributes?.[attributeName + deviceString]?.bottom}
                className="softlite-rectangle-input softlite-bottom-input softlite-text-center"
                placeholder="Bottom"
            />
        </div>
    );
};

export default DimensionsControl;
